import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  provideHttpClient,
  withFetch,
  withInterceptors
} from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { ApiErrorInterceptor } from '@app/core/interceptor/api-error.interceptor';
import { registerLocaleData } from '@angular/common';
import localeDa from '@angular/common/locales/da';
import { callGuardInterceptor } from '@app/core/interceptor/call-guard.interceptor';
import { versionUpdateInterceptor } from '@app/core/interceptor/version-update.interceptor';

registerLocaleData(localeDa)

/**
 * Configuration object for the application.
 *
 * This object defines the necessary providers and dependencies required to set up the application.
 * It includes setup for various services, HTTP interceptors, authentication mechanisms, routing,
 * HTTP client configuration, and internationalization support.
 *
 * The providers array contains a list of services and factories to be injected where required,
 * ensuring proper application functionality.
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        callGuardInterceptor,
        versionUpdateInterceptor,
        ApiErrorInterceptor,
      ])
    ),
    provideTranslateService({
      fallbackLang: 'da'
    }),
    {
      provide: LOCALE_ID,
      useValue: 'da'
    }
  ]
};
